<!-- Topbar Start -->
<div class="navbar-custom">
    <div class="container-fluid">
        <ul class="list-unstyled topnav-menu float-end mb-0">


            <!-- <li class="d-inline-block d-lg-none" ngbDropdown placement="bottom-start">
                <a class="nav-link arrow-none waves-effect waves-light" href="javascript:void(0);" role="button"
                    ngbDropdownToggle>
                    <i class="fe-search noti-icon black"></i>
                </a>
                <div class="dropdown-menu-end  dropdown-lg p-0 noti-dropdown" ngbDropdownMenu>
                    <form class="p-3" ngbDropdownItem>
                        <input type="text" class="form-control" placeholder="Search ..."
                            aria-label="Recipient's username">
                    </form>
                </div>
            </li> -->

            <!-- full screen button -->
            <!-- <li class="dropdown d-none d-lg-inline-block">
                <a class="nav-link dropdown-toggle arrow-none waves-effect waves-light maximize-icon"
                    href="javascript:void(0)" (click)="toggleFullScreen()">
                    <i class="fe-maximize noti-icon"></i>
                </a>
            </li> -->

           

            <!-- languages -->
            <!-- <li class=" d-lg-inline-block topbar-dropdown" ngbDropdown>
                <a class="nav-link arrow-none waves-effect waves-light" href="javascript:void(0)" role="button"
                    ngbDropdownToggle>
                    <img (click)="selectMobileLanguage()" [src]="getSelectedLanguageFlag()" alt="user-image"
                        class="flag" height="16">
                </a>
                <div class="dropdown-menu-end" ngbDropdownMenu>
                    <a (click)="changeLanguage(language)" ngbDropdownItem *ngFor="let language of languages">
                        <img [src]="language.flag" alt="user-image" class="me-1" height="12"> <span
                            class="align-middle">{{language.name}}</span>
                    </a>

                </div>
            </li> -->

             <!-- task -->
             <!-- <li class="notification-list topbar-dropdown" *ngIf="loggedInUser?.role == userRole.MEMBER || loggedInUser?.role == userRole.ADMIN" (click)="taskToggle.toggle($event); clickTask()">
                <a class="nav-link waves-effect waves-light"  href="javascript:void(0)" role="button">
                    <i class="mdi mdi-timer-outline black"></i>
                    <div *ngIf="isActive"
                        class="dot-notif"></div>
                </a>
                <p-overlayPanel appendTo="body" [showCloseIcon]="true" #taskToggle [baseZIndex]="999999999999">
                    <ng-container *ngTemplateOutlet="ListCards;"></ng-container>
                </p-overlayPanel>
            </li> -->

            <!-- chat -->
            <!-- <li class="notification-list topbar-dropdown" >
                <a class="nav-link waves-effect waves-light"  href="" role="button">
                    <i class="mdi mdi-chat-outline black"></i>
                    <div class="dot-notif"></div>
                </a>
            </li> -->

            <!-- notification list -->
           <!--  <li class="notification-list topbar-dropdown" ngbDropdown>
                <a class="nav-link waves-effect waves-light" href="javascript:void(0)" role="button" ngbDropdownToggle>
                    <i (click)="notifyIcon()" class="mdi mdi-bell-outline black"></i>
                    <div *ngIf="totalNotRead > 0"
                        class="dot-notif"></div>
                </a>
                <div class="dropdown-menu-end dropdown-lg" ngbDropdownMenu>
                     <div class="noti-title" ngbDropdownItem>
                        <h5 class="m-0">
                            {{'NOTIFICATIONS.NOTIFICATIONS' | translate}}
                        </h5>
                    </div>

                    <ngx-simplebar class="noti-scroll">
                        <div (click)="moveToNotificationScreen(item.id)" class="notify-item" [class.active]="!item.read"
                            *ngFor="let item of notificationList" ngbDropdownItem>

                            <p class="notify-details">{{item.subject}}</p>
                            <div class="notify-extra d-flex justify-content-between">

                                <p class="text-muted mb-0 user-msg">
                                    <small>{{item.createdAt | date: 'YYYY-MM-dd' }}</small>
                                </p>
                                <p (click)="markAsRead($event,item.id)"  class="mb-0 user-msg markNot">
                                    {{'NOTIFICATIONS.MARKREAD'| translate}}
                                </p> 
                            </div>
                        </div>
                    </ngx-simplebar>
                     <a (click)="moveToNotificationScreen()"
                        class="dropdown-item text-center text-primary notify-item notify-all">
                        {{'NOTIFICATIONS.VIEW' | translate}}
                        <i class="fe-arrow-right"></i>
                    </a>

                </div>
            </li> -->

            <!-- profile menu -->
            <li class="dropdown notification-list  topbar-dropdown" ngbDropdown>
                <a ngbDropdownToggle class="nav-link nav-user  me-0 waves-effect waves-light" id="profileMenuDropdown"
                    href="javascript:void(0)" aria-expanded="false">
                    <span (click)="profileIcon()" class="account-user-avatar"
                        *ngIf="accountPhoto !== 'null' && accountPhoto!== null && accountPhoto!== undefined">
                        <img [src]="accountPhoto" alt="user-image" class="rounded-circle avatarHeader">
                    </span>
                    <span class="pro-user-name ms-1 black textFormat">
                        {{loggedInUser?.firstName}} <i class="mdi mdi-chevron-down black"></i>
                    </span>

                </a>
                <div ngbDropdownMenu aria-labelledby="profileMenuDropdown" class="dropdown-menu-end profile-dropdown">
                    <!-- item -->
                    <div ngbDropdownItem class="dropdown-header noti-title">
                        <h6 class="text-overflow m-0">{{ 'TOP_USER_MENU.WELCOME' | translate }} !</h6>
                    </div>
                    <!-- item -->
                    <a *ngFor="let option of profileOptions" class="notify-item" ngbDropdownItem
                        style="cursor: pointer;" [routerLink]="option.redirectTo">
                        <i class="{{option.icon}} me-1"></i>
                        <span>{{option.label | translate }}</span>
                    </a>
                </div>
            </li>
        </ul>


        <ul class="list-unstyled topnav-menu topnav-menu-left m-0">
            <li>
                <button class="button-menu-mobile waves-effect waves-light d-none d-lg-block"
                    (click)="changeSidebarWidth()" *ngIf="layoutType!=='horizontal'">
                    <i class="fe-menu black"></i>
                </button>
            </li>

           <!--  <li>
                <button class="button-menu-mobile open-left d-block d-lg-none waves-effect waves-light"
                    *ngIf="layoutType!=='horizontal'" (click)="toggleMobileMenu($event)">
                    <i class="fe-menu black"></i>
                </button>
            </li>


            <li *ngIf="'sales:requests:create' | hasPermission" class="d-none d-xl-block new-menu" ngbDropdown>
                <a class="nav-link waves-effect waves-light textFormat" href="javascript:void(0)" role="button"
                    ngbDropdownToggle>
                    {{ 'TOP_MENU.CREATE_NEW' | translate }}
                    <i class="mdi mdi-chevron-down black"></i>
                </a>
                <div ngbDropdownMenu>
                    <ng-container *ngFor="let option of createMenuOptions;let i=index">
                        <div class="dropdown-divider" *ngIf="i===createMenuOptions.length-1"></div>
                        <a [href]="option.link" ngbDropdownItem>
                            <i class="{{option.icon}} me-1"></i>
                            <span>{{ option.label | translate }}</span>
                        </a>
                    </ng-container>
                </div>
            </li> -->
        </ul>
        <div class="clearfix"></div>
    </div>
</div>


<ng-template #ListCards>
    <app-times-info-top-bar #infoTopBar> </app-times-info-top-bar>
</ng-template>

<app-task-view-modal></app-task-view-modal>
<!-- end Topbar -->